"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var Weeks_1 = __importDefault(require("../Weeks/Weeks"));
var DayNames_1 = __importDefault(require("../DayNames/DayNames"));
var react_1 = require("react");
var Body = /** @class */ (function (_super) {
    __extends(Body, _super);
    function Body() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.genBody = function (month) {
            var _a = _this.props, selected = _a.selected, select = _a.select, from = _a.from, to = _a.to;
            return (React.createElement("div", { className: "month-wrap" },
                React.createElement(DayNames_1.default, { moment: month }),
                React.createElement(Weeks_1.default, { select: select, month: month, disabled: _this.configDisabled(), selected: selected, from: from, to: to })));
        };
        _this.genClasses = function () {
            var _a = _this.props, highlightWeekends = _a.highlightWeekends, className = _a.className, range = _a.range;
            var classes = 'ui date-picker-calendar';
            if (className) {
                classes += ' ' + className;
            }
            if (highlightWeekends) {
                classes += ' highlight-weekends';
            }
            if (range) {
                classes += ' range-select';
            }
            return classes;
        };
        _this.configDisabled = function () {
            var _a = _this.props, disablePast = _a.disablePast, disableFuture = _a.disableFuture, disableWeekends = _a.disableWeekends;
            var disabled = {
                past: disablePast ? true : false,
                future: disableFuture ? true : false,
                daysOfWeek: disableWeekends ? [0, 6] : []
            };
            return disabled;
        };
        return _this;
    }
    Body.prototype.render = function () {
        var _a = this.props, month = _a.month, range = _a.range;
        return (React.createElement("div", { className: this.genClasses() },
            this.genBody(month),
            range && this.genBody(month.clone().add(1, 'month'))));
    };
    Body.defaultProps = {
        highlightWeekends: false,
        showYears: false,
        disablePast: false,
        disableFuture: false,
        disableWeekends: false
    };
    return Body;
}(react_1.Component));
exports.default = Body;
